import Dexie, { Table } from 'dexie'

// export const TOKEN_ID = 999
export const LANG_ID = 555
export const VERIFIER_ID = 555

// export interface ITokens {
//   id: number
//   // token?: string
//   refresh_token?: string
// }

export interface ILang {
  id: number
  lang: string
}

export interface IVerifierCode {
  id: number
  verifierCode: string
}

export class IndexDbByDexie extends Dexie {
  // tokens: Table<ITokens>

  lang: Table<ILang>

  verifierCode: Table<IVerifierCode>

  constructor() {
    super('store')
    this.version(1).stores({
      // tokens: '&id, refresh_token',
      lang: '&id, lang',
      verifierCode: '&id, code'
    })
    // this.tokens = this.table('tokens')
    this.lang = this.table('lang')
    this.verifierCode = this.table('verifierCode')
  }
}

export const db = new IndexDbByDexie()
